import React from 'react';
import MypagePaymentArtistContainer from 'containers/MypagePaymentArtistContainer';

export default function MypagePaymentArtistPage() {
  return <MypagePaymentArtistContainer />;
}
